import { useCallback } from 'react';
import Passwordless from './Passwordless';
import Login from './Login';
import Register from './Register';

interface LoginFormModalProps {
    visible: boolean;
    onCancel: () => void;
    type: string;
    isRegister?: boolean;
}

export default function LoginFormModal({ visible, onCancel, type, isRegister }: LoginFormModalProps) {
    const handleCancel = useCallback(() => {
        onCancel();
    }, [onCancel]);

    if (!type) return null;

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999 !important;
                    }
                `}
            </style>
            {type === 'login' && <Login visible={visible} onCancel={handleCancel} />}
            {type === 'register' && <Register visible={visible} onCancel={handleCancel} />}
            {type === 'passwordless' && <Passwordless visible={visible} onCancel={handleCancel} isRegister={isRegister} />}
        </>
    );
}
